// SGP Market Type Constants
export const SGP_MARKET_TYPES = {
  // Winner markets
  WINNER: 0,
  WINNER_1ST_HALF: 1001,
  WINNER_2ND_HALF: 1002,

  // Total markets
  TOTAL: 10002,
  TOTAL_1ST_HALF: 10003,
  TOTAL_2ND_HALF: 10004,

  // Spread markets
  SPREAD: 10005,
  SPREAD_1ST_HALF: 10006,
  SPREAD_2ND_HALF: 10007,

  // Both teams to score
  BOTH_TEAMS_TO_SCORE: 10009,

  // Double chance
  DOUBLE_CHANCE: 10010,

  // Draw no bet
  DRAW_NO_BET: 10011,

  // Correct score
  CORRECT_SCORE: 10012,

  // Player props
  PLAYER_POINTS: 20001,
  PLAYER_REBOUNDS: 20002,
  PLAYER_ASSISTS: 20003,
  PLAYER_THREES: 20004,
  PLAYER_DOUBLE_DOUBLE: 20005,
  PLAYER_TRIPLE_DOUBLE: 20006,

  // Football specific
  GOAL_SCORER: 30001,
  SHOTS_ON_GOAL: 30002,
  CORNERS: 30003,
  CARDS: 30004,

  // Tennis specific
  SET_WINNER: 40001,
  GAME_WINNER: 40002,
  ACE_COUNT: 40003,

  // Baseball specific
  RUNS: 50001,
  HITS: 50002,
  STRIKEOUTS: 50003,

  // Hockey specific
  GOALS: 60001,
  SAVES: 60002,
  PENALTIES: 60003,
} as const
